export default __webpack_public_path__ + "static/media/profit.8ea62bc0.svg";